import {
  TAG_LIST_GET,
  TAG_LIST_GET_SUCCESS,
  TAG_LIST_GET_ERROR,
  TAG_CREATE,
  TAG_CREATE_SUCCESS,
  TAG_CREATE_ERROR,
  TAG_UPDATE,
  TAG_UPDATE_SUCCESS,
  TAG_UPDATE_ERROR,
  TAG_DELETE,
  TAG_DELETE_SUCCESS,
  TAG_DELETE_ERROR,
} from './type'

export const getTagListAction = callback => ({
  type: TAG_LIST_GET,
  payload: { callback },
})

export const getTagListSuccess = list => ({
  type: TAG_LIST_GET_SUCCESS,
  payload: list,
})

export const getTagListError = () => ({ type: TAG_LIST_GET_ERROR })

export const createTagAction = (entity, callback, onError) => ({
  type: TAG_CREATE,
  payload: { entity, callback, onError },
})

export const createTagSuccess = tag => ({
  type: TAG_CREATE_SUCCESS,
  payload: tag,
})

export const createTagError = () => ({ type: TAG_CREATE_ERROR })

export const updateTagAction = (id, entity, callback) => ({
  type: TAG_UPDATE,
  payload: { id, entity, callback },
})

export const updateTagSuccess = tag => ({
  type: TAG_UPDATE_SUCCESS,
  payload: tag,
})

export const updateTagError = () => ({ type: TAG_UPDATE_ERROR })

export const deleteTagAction = (id, callback) => ({
  type: TAG_DELETE,
  payload: { id, callback },
})

export const deleteTagSuccess = id => ({
  type: TAG_DELETE_SUCCESS,
  payload: id,
})

export const deleteTagError = () => ({ type: TAG_DELETE_ERROR })
